import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgAngleRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.554,
    height: 13.125,
    viewBox: "0 0 7.554 13.125"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.316 5.839L5.874.291a.983.983 0 111.394 1.385l-4.861 4.91 4.861 4.861a.983.983 0 11-1.394 1.385L.316 7.282a.982.982 0 010-1.444z",
    fill: "#202124"
  })));
}

export { SvgAngleRight as ReactComponent };
//# sourceMappingURL=AngleRight.svg.js.map
